import { Store } from '@ngrx/store';
import { Component, Input, OnInit } from '@angular/core';

import { AppState } from '../../../../interfaces/app-state.interface';
import { AdvisorEntity } from '../../../../entities/advisor.entity';
import { ActionEventsEnum } from '../../../../enum/tracking/action-events.enum';
import { fadeInOutAnimation } from '../../../../animations/fadeInOut';


interface IAdvisorContact {
    name: string;
    value: string,
    label: string,
    iconUrl: string;
    mobileLink: string,
    animationState: 'initial' | 'final',
};

@Component({
    selector: 'tr-advisor-contact',
    templateUrl: './advisor-contact.component.html',
    styleUrls: ['./advisor-contact.component.scss'],
    animations: [fadeInOutAnimation],
})
export class AdvisorContactComponent implements OnInit {

    @Input()
    public advisor: AdvisorEntity;

    public contacts: IAdvisorContact[] = []

    constructor(private store: Store<AppState>) {}

    public ngOnInit(): void {
        if (this.advisor.email) {
            this.contacts.push({
                name: 'email',
                label: 'Email',
                value: this.advisor.email,
                mobileLink: `mailto:${this.advisor.email}`,
                iconUrl: 'home/assets/svg-icons/email.svg',
                animationState: 'initial',
            });
        }
        
        if (this.advisor.phone || this.advisor.mobilePhone) {
            this.contacts.push({
                name: 'phone',
                label: 'Telefone',
                value: this.advisor.phone || this.advisor.mobilePhone,
                mobileLink: `tel:${this.advisor.phone}`,
                iconUrl: 'home/assets/svg-icons/phone.svg',
                animationState: 'initial',
            });
        }
    }

    /**
     * Determina se o cliente está em mobile
     */
    public get isMobile(): boolean {
        return window.innerWidth <= 768;
    }

    /**
     * Copia o valor de um cotato para a área de transferência
     *
     * @param element
     * @param data
     */
    public copyContactToClipboard(contact: IAdvisorContact) {

        // Animação de cópia
        contact.animationState = 'final';
        setTimeout(() => contact.animationState = 'initial', 2000);

        // Copia valor
        navigator.clipboard.writeText(contact.value);

        // Dispara evento de métrica
        this.store.dispatch(
            this.advisor.getAnalyticsEvent(
                ActionEventsEnum.USER_CLICKED,
                `[Botão] Copiar ${contact.label}`,
            )
        );

    }

}